export default __webpack_public_path__ + "static/media/australia.831dbca5.jpg";